import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The AI "Generate" action next to a form field. While `loading`, it shows an
 * inline spinner and ignores clicks; only this button is busy, so the rest of
 * the form stays usable during a slow /generative/* call.
 */
@Component({
  selector: 'app-ai-generate-button',
  standalone: true,
  templateUrl: './fnf-ai-generate-button.component.html',
  styleUrl: './fnf-ai-generate-button.component.css',
})
export class FnfAiGenerateButtonComponent {
  @Input() loading = false;
  @Input() disabled = false;
  @Output() generate = new EventEmitter<void>();

  onClick(): void {
    if (!this.loading && !this.disabled) {
      this.generate.emit();
    }
  }
}
